import { createContext, useContext } from "react";

export const EditorReadyContext = createContext(() => {});

export const useSignalEditorReady = () => useContext(EditorReadyContext);
